import { render, staticRenderFns } from "./ChartEfficiency.vue?vue&type=template&id=646cd897&scoped=true&"
import script from "./ChartEfficiency.vue?vue&type=script&lang=js&"
export * from "./ChartEfficiency.vue?vue&type=script&lang=js&"
import style0 from "./ChartEfficiency.vue?vue&type=style&index=0&id=646cd897&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "646cd897",
  null
  
)

export default component.exports